import React from "react";
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import WorkHistory from '@mui/icons-material/WorkHistory';
import { Typography } from "@mui/material";
import { ui } from "../../../../../../interfaces/interfaces";
import { useAppSelector } from "@store/hooks";

const handleMainMenuClose = () => {
    ui.MainMenuModal = false;
};

type MainMenuProps = {
    anchorEl: HTMLElement | null;
    menuId: string;
}


const MainMenu: React.FC<MainMenuProps> = ({ anchorEl, menuId }) => {
    const mainMenuModal = useAppSelector(({ ui }) => ui.MainMenuModal);
    return (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            open={mainMenuModal}
            onClose={handleMainMenuClose}
        >
            {/* <MenuItem onClick={() => {
                handleMainMenuClose()
                ui.FailDialogModal = true
            }}>
                <ListItemIcon >
                    <WorkHistory fontSize="small" />
                </ListItemIcon>
                <Typography variant="inherit">Fail booking</Typography>
            </MenuItem> */}
            <MenuItem onClick={() => {
                handleMainMenuClose()
                ui.JobSearchModal = true
            }}>
                <ListItemIcon >
                    <WorkHistory fontSize="small" />
                </ListItemIcon>
                <Typography variant="inherit">Search Jobs</Typography>
            </MenuItem>
        </Menu>
    );
}

export default React.memo(MainMenu);